var _defs, _rect, _path, _path2, _circle, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShakenWh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}.c{fill:#002445;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(0 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.613,30.571V26.516L8.841,23.7l4.972-5.159H26.737l3.65,5.159v7.128Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.387,31.582H30.38L4.605,31.321a.75.75,0,0,1-.742-.75V26.516a.75.75,0,0,1,.335-.625l4.16-2.767,4.915-5.1a.75.75,0,0,1,.54-.23H26.737a.75.75,0,0,1,.612.317L31,23.271a.75.75,0,0,1,.138.433v7.128a.75.75,0,0,1-.75.75ZM5.363,29.829l24.274.246V23.942L26.349,19.3H14.131l-4.75,4.929a.751.751,0,0,1-.125.1L5.363,26.918Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(8.896 27.416)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(8.896 27.416)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.98,
    cy: 2.98,
    r: 2.98,
    transform: "translate(21.262 27.416)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.98-.75A3.73,3.73,0,1,1-.75,2.98,3.734,3.734,0,0,1,2.98-.75Zm0,5.959A2.23,2.23,0,1,0,.75,2.98,2.232,2.232,0,0,0,2.98,5.209Z",
    transform: "translate(21.262 27.416)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.293,24.454H8.841v-1.5h10.7V18.881h1.5V23.7A.75.75,0,0,1,20.293,24.454Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M30.387,24.454H23.124a.75.75,0,0,1-.75-.75V18.881h1.5v4.073h6.513Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.257,10l2.959,1.968L23.245,6.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.215,12.715a.748.748,0,0,1-.415-.126l-2.959-1.968a.75.75,0,0,1,.831-1.249l2.416,1.607,4.6-5.18a.75.75,0,1,1,1.122,1l-5.029,5.668A.749.749,0,0,1,18.215,12.715Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.25-.75a8,8,0,1,1-8,8A8.009,8.009,0,0,1,7.25-.75Zm0,14.5a6.5,6.5,0,1,0-6.5-6.5A6.507,6.507,0,0,0,7.25,13.75Z",
    transform: "translate(12.25 1.625)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShakenWh);
export default __webpack_public_path__ + "static/media/icon_shaken_wh.e83d840feedd5792abb0436bdfd0b7db.svg";
export { ForwardRef as ReactComponent };